import {PlanTypeEnum, UserTypeEnum} from 'presentation/constants';

export enum GenderEnum {
	FEMALE = 'F',
	MALE = 'M',
	WOMAN = 'FEMININO',
	MAN = 'MASCULINO',
}

export enum BeneficiarySituationEnum {
	ACTIVE = 'ATIVO',
	CANCELLED = 'CANCELADO',
}

export type GetBeneficiaryParams = {
	nmPlano?: string;
	nuContrato?: string;
	signal?: AbortSignal;
};

export type BeneficiaryModel = {
	nuContrato: string;
	nmUsuario: string;
	nmSocialUsuarioC: string | null;
	nuCpf: string;
	nuCpfC: string;
	nuCNS: number | null;
	idadeC: number;
	flSexoUsuario: GenderEnum;
	flSexoUsuarioC: GenderEnum;
	nmUsuarioC: string;
	tipoUsuarioC: UserTypeEnum;
	nuContratoC: string;
	tipoPlanoC: PlanTypeEnum;
	nmPlano: string;
	nuRegistroPlano: string;
	tipoContratacao: string;
	dtCarenciaC: string;
	dtCarenciaOdontoC: string;
	dtNascimentoUsuarioC: string;
	dtAdesaoC: string;
	cdPessoa: string;
	cdUsuarioC: string;
	cdUsuarioEspelhado: string;
	cdPessoaC: string;
	flTitularSemDireito: boolean;
	situacao: BeneficiarySituationEnum;
	dtCancelamentoC: string;
	dsStatusUsuario: BeneficiarySituationEnum;
	dataCancelamento?: string | null;
	acessoSuspenso?: boolean;
	cdUsuario: string;
	cdEmpresaPlano?: number;
	flPermitido: 'S' | 'N';
};

export type GetBeneficiaryModel = {
	beneficiarios: BeneficiaryModel[];
};

export interface GetBeneficiary {
	get: (params: GetBeneficiaryParams) => Promise<GetBeneficiaryModel>;
}
